import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQualifications = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 16,
	viewBox: "0 0 25 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Group",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Group_2",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M24.6757 4.53181L12.6757 0.0317874C12.5624 -0.0105958 12.438 -0.0105958 12.3247 0.0317874L0.324612 4.53181C0.129496 4.60505 0 4.79158 0 4.99998C0 5.20857 0.129491 5.39509 0.324417 5.46814L2.50003 6.28415V11.5002C2.50003 11.7763 2.72386 12.0002 3.00003 12.0002C3.2762 12.0002 3.50003 11.7763 3.50003 11.5002V6.65935L5.50004 7.40936V14.5004C5.50004 14.5719 5.51606 14.6391 5.54301 14.7006C5.97388 15.8246 10.0268 16.0004 12.5001 16.0004C14.9733 16.0004 19.0261 15.8246 19.4571 14.7006C19.484 14.6391 19.5001 14.5719 19.5001 14.5004V7.40936L24.6756 5.46855C24.8705 5.39531 25 5.20878 25 5.00018C25 4.79178 24.8705 4.60526 24.6756 4.53202L24.6757 4.53181ZM18.5002 13.6109C17.0519 13.0986 14.3402 13.0001 12.5002 13.0001C10.6601 13.0001 7.94838 13.0985 6.50012 13.6109V6.37232C10.4835 5.21606 14.5167 5.21606 18.5002 6.37232V13.6109ZM12.5002 15.0001C9.65619 15.0001 7.78078 14.7347 6.92712 14.5001C7.78083 14.2655 9.65604 14.0001 12.5002 14.0001C15.3441 14.0001 17.2195 14.2655 18.0732 14.5001C17.2195 14.7349 15.3441 15.0001 12.5002 15.0001ZM19.5002 6.34107V6.00025C19.5002 5.78072 19.3572 5.58697 19.1471 5.52251C14.7363 4.1651 10.2635 4.1651 5.85299 5.52251C5.64303 5.58677 5.50006 5.78072 5.50006 6.00005V6.34088L1.92404 5.00007L12.5001 1.03405L23.0762 5.00007L19.5002 6.34107Z"
			})
		})
	})
});
export default SvgQualifications;
